import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "modal", "title", "message", "form"]
  static values = {
    title: String,
    message: String
  }
  
  open(event) {
    event.preventDefault()
    
    // Get title and message from the trigger element's data attributes
    const trigger = event.currentTarget
    const title = trigger.dataset.confirmTitle || this.titleValue || "Confirm Action"
    const message = trigger.dataset.confirmMessage || this.messageValue || "Are you sure?"
    const formId = trigger.dataset.confirmFormId
    
    // Update modal content
    if (this.hasTitleTarget) {
      this.titleTarget.textContent = title
    }
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = message
    }
    
    // Store the form ID to submit on confirm
    this.formToSubmit = formId
    
    // Show modal
    this.backdropTarget.classList.remove("opacity-0", "pointer-events-none")
    this.backdropTarget.classList.add("opacity-100")
    this.modalTarget.classList.remove("opacity-0", "scale-95", "pointer-events-none")
    this.modalTarget.classList.add("opacity-100", "scale-100")
    document.body.classList.add("overflow-hidden")
  }
  
  close() {
    this.backdropTarget.classList.add("opacity-0", "pointer-events-none")
    this.backdropTarget.classList.remove("opacity-100")
    this.modalTarget.classList.add("opacity-0", "scale-95", "pointer-events-none")
    this.modalTarget.classList.remove("opacity-100", "scale-100")
    document.body.classList.remove("overflow-hidden")
    this.formToSubmit = null
  }
  
  confirm() {
    if (this.formToSubmit) {
      const form = document.getElementById(this.formToSubmit)
      if (form) {
        form.requestSubmit()
      }
    }
    this.close()
  }
  
  // Close on escape key
  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
  
  // Close when clicking backdrop
  closeOnBackdrop(event) {
    if (event.target === this.backdropTarget) {
      this.close()
    }
  }
}
